export default __webpack_public_path__ + "static/media/PowellCatLocation-03.9bcd1612.jpg";